import { useState, useEffect } from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const AdditionalInfoPanel = ({
  isAdditionalInfoPanelOpen,
  onClose,

  // existing props
  kraPin,
  setKraPin,
  monthlyIncome,
  setMonthlyIncome,
  jobTitle,
  setJobTitle,
  employment_type,
  setEmploymentType,

  // address props (NEW)
  countryOfResidence,
  setCountryOfResidence,
  county,
  setCounty,
  subCounty,
  setSubCounty,
  physicalAddress,
  setPhysicalAddress,
  counties,
  countries,

  loading,
  handleAdditionalInfor,
}) => {
  const [isInputsFilled, setIsInputsFilled] = useState(false);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [subCounties, setSubCounties] = useState([]);
  const [formattedIncome, setFormattedIncome] = useState(""); // display value

  const handleChange = (e) => {
    let value = e.target.value;

    // Remove anything that's not a digit
    const rawValue = value?.replace(/[^0-9]/g, "");

    // Format with commas
    const formattedValue = new Intl.NumberFormat().format(rawValue);

    setMonthlyIncome(rawValue); // clean value (e.g., 10000)
    setFormattedIncome(formattedValue); // display value (e.g., 10,000)
  };

  // ✅ County → Subcounty logic (UNCHANGED)
  useEffect(() => {
    const selectedCounty = counties?.find((c) => c?.county === county);
    if (selectedCounty) {
      setSubCounties(selectedCounty?.sub_counties);
    } else {
      setSubCounties([]);
    }
  }, [county, counties]);

  // ✅ Countries filter (UNCHANGED)
  useEffect(() => {
    const filtered = countries
      ?.filter((c) => c?.name)
      ?.sort((a, b) => a.name.localeCompare(b.name));

    setFilteredCountries(filtered);
  }, [countries]);

  useEffect(() => {
    const areInputsFilled =
      kraPin?.trim() !== "" &&
      monthlyIncome?.toString().trim() !== "" &&
      employment_type?.trim() !== "" &&
      jobTitle?.trim() !== "" &&
      countryOfResidence?.trim() !== "" &&
      county?.trim() !== "" &&
      subCounty?.trim() !== "" &&
      physicalAddress?.trim() !== "";

    setIsInputsFilled(areInputsFilled);
  }, [
    kraPin,
    monthlyIncome,
    employment_type,
    jobTitle,
    countryOfResidence,
    county,
    subCounty,
    physicalAddress,
  ]);

  return (
    <SlidePanel isOpen={isAdditionalInfoPanelOpen} onClose={onClose}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <div
          onClick={onClose}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="mt-5 px-5">
            <p className="text-[#000] text-xl font-bold">
              New Member - Additional Information
            </p>
            <p className="text-[15px]">
              Enter member’s income, KRA PIN and address details.
            </p>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-y-auto px-5 pb-6 mt-5">
            <div className="flex flex-col gap-5">
              {/* KRA PIN */}
              <div className="flex flex-col">
                <label>KRA PIN</label>
                <input
                  type="text"
                  placeholder="Enter KRA PIN (e.g. A123456789X)"
                  value={kraPin}
                  onChange={(e) => setKraPin(e.target.value)}
                  className="input"
                />
              </div>

              {/* Employment */}
              <div className="flex flex-col">
                <label>Employment type</label>
                <select
                  value={employment_type}
                  onChange={(e) => setEmploymentType(e.target.value)}
                  className="input"
                >
                  <option value="">Select employment type</option>
                  <option value="Employed">Employed</option>
                  <option value="SelfEmployed">Self Employed</option>
                </select>
              </div>

              {/* Job */}
              <div className="flex flex-col">
                <label>Job Title</label>
                <input
                  type="text"
                  placeholder="Enter job title (e.g. Accountant)"
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                  className="input"
                />
              </div>

              {/* Income */}
              <div className="flex flex-col">
                <label>Monthly Income</label>
                <div className="flex items-center input">
                  <div className="w-[8%] border-r">KES</div>
                  <input
                    type="text"
                    placeholder="Enter monthly income (e.g. 50,000)"
                    value={formattedIncome}
                    onChange={handleChange}
                    className="w-full bg-transparent px-3"
                  />
                </div>
              </div>

              {/* ===================== */}
              {/* ADDRESS SECTION 🔥 */}
              {/* ===================== */}

              {/* <p className="font-semibold mt-4">Address Information</p> */}

              {/* Country */}
              <div className="flex flex-col">
                <label>Country of Residence</label>
                <select
                  value={countryOfResidence}
                  onChange={(e) => setCountryOfResidence(e.target.value)}
                  className="input"
                >
                  <option value="">Select country of residence</option>
                  {filteredCountries?.map((c) => (
                    <option key={c?.id} value={c?.name}>
                      {c?.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* County + Subcounty */}

              <div className="flex flex-col">
                <label>County</label>
                <select
                  value={county}
                  onChange={(e) => setCounty(e.target.value)}
                  className="input"
                >
                  <option value="">Select county</option>
                  {counties?.map((c) => (
                    <option key={c.id} value={c.county}>
                      {c.county}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex flex-col">
                <label>Sub-county</label>
                <select
                  value={subCounty}
                  onChange={(e) => setSubCounty(e.target.value)}
                  className="input"
                >
                  <option value="">Select sub-county</option>
                  {subCounties?.map((sc) => (
                    <option key={sc} value={sc}>
                      {sc}
                    </option>
                  ))}
                </select>
              </div>

              {/* Town + Physical */}

              {/* <div className="flex flex-col">
                <label>Town</label>
                <input
                  type="text"
                  placeholder="Enter town (e.g. Westlands)"
                  value={town}
                  onChange={(e) => setTown(e.target.value)}
                  className="input"
                />
              </div> */}

              <div className="flex flex-col">
                <label>Physical Address</label>
                <input
                  type="text"
                  placeholder="Enter physical address (e.g. ABC Plaza, 3rd Floor)"
                  value={physicalAddress}
                  onChange={(e) => setPhysicalAddress(e.target.value)}
                  className="input"
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="p-4">
            <button
              onClick={handleAdditionalInfor}
              disabled={!isInputsFilled || loading}
              className={`w-full text-white px-6 py-2 rounded flex items-center justify-center
                ${isInputsFilled ? "bg-[#074073]" : "bg-[#D9D9D9]"}
                ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Completing ...
                </div>
              ) : (
                "Complete"
              )}
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default AdditionalInfoPanel;
